import { useEffect, useState } from 'react';
import { benefitsApi } from '../../../api/benefits.js';

const fmtDt = (v) => (v ? new Date(v).toLocaleString() : '—');

export default function EnrollmentWindows() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState(null);

  function refresh() {
    setLoading(true);
    benefitsApi.listWindows()
      .then((d) => setItems(d?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    // Capture the form node before any await: React nulls `e.currentTarget`
    // once the event handler returns, so reading it post-await throws.
    const form = e.currentTarget;
    const fd = new FormData(form);
    try {
      await benefitsApi.createWindow({
        plan_year: Number(fd.get('plan_year')),
        opens_at: new Date(fd.get('opens_at')).toISOString(),
        closes_at: new Date(fd.get('closes_at')).toISOString(),
        status: 'scheduled',
      });
      form.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create');
    }
  }

  async function transition(id, action) {
    try {
      if (action === 'open') await benefitsApi.openWindow(id);
      else await benefitsApi.closeWindow(id);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || `Failed to ${action}`);
    }
  }

  return (
    <section data-testid="benefits-windows-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Enrollment Windows</h1>
          <p className="muted">{items.length} windows</p>
        </div>
        <button className="btn primary" data-testid="benefits-window-create" onClick={() => setShowForm((s) => !s)}>
          {showForm ? 'Close' : '+ New Window'}
        </button>
      </header>

      {error && <div className="alert error" data-testid="benefits-windows-error">{error}</div>}

      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Plan Year<input name="plan_year" type="number" min="2024" defaultValue={new Date().getFullYear()} data-testid="benefits-window-year-input" required /></label>
          <label>Opens At<input name="opens_at" type="datetime-local" data-testid="benefits-window-opens-input" required /></label>
          <label>Closes At<input name="closes_at" type="datetime-local" data-testid="benefits-window-closes-input" required /></label>
          <div className="full actions">
            <button className="btn primary" type="submit" data-testid="benefits-window-submit">Create Window</button>
          </div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="benefits-window-list">
          <thead>
            <tr><th>Plan Year</th><th>Opens</th><th>Closes</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((w) => (
              <tr key={w.id} data-testid={`benefits-window-row-${w.id}`}>
                <td>{w.plan_year}</td>
                <td>{fmtDt(w.opens_at)}</td>
                <td>{fmtDt(w.closes_at)}</td>
                <td>
                  <span className={`chip status-${w.status}`} data-testid={`benefits-window-status-${w.id}`}>
                    {w.status}
                  </span>
                </td>
                <td className="actions-cell">
                  {w.status === 'scheduled' && (
                    <button className="btn small" data-testid={`benefits-window-open-${w.id}`} onClick={() => transition(w.id, 'open')}>Open</button>
                  )}
                  {w.status === 'open' && (
                    <button className="btn small danger" data-testid={`benefits-window-close-${w.id}`} onClick={() => transition(w.id, 'close')}>Close</button>
                  )}
                </td>
              </tr>
            ))}
            {!loading && items.length === 0 && (
              <tr><td colSpan={5} className="muted">No enrollment windows yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
